
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ConfirmDialog extends Vue {
    @Prop({ type: String, required: true })
    public readonly body!: string;

    @Prop({ type: String, required: false, default: null })
    public readonly declineLabel!: string | null;

    @Prop({ type: String, required: false, default: null })
    public readonly confirmLabel!: string | null;

    @Prop({ type: Boolean, required: false, default: false })
    public readonly value!: boolean;

    public onConfirm(): void {
        this.onClose();
        this.$emit('confirm');
    }

    public onDecline(): void {
        this.onClose();
        this.$emit('decline');
    }

    public onClose(): void {
        this.$emit('input', false);
    }
}
